import { createFileRoute } from '@tanstack/react-router'
import { ApprovalsView } from '../../../modules/approvals/approvals-view'

/**
 * `/approvals` - the global approvals queue (gap-02). Every agent step that needs
 * a human decision before it runs (risky approval-gated steps + pending dry-runs)
 * lists here with approve / reject. Reads the live `approval.list` capability when
 * present, else derives from agent runs so it renders against the mock runtime.
 */
export const Route = createFileRoute('/_authed/approvals/')({
  component: ApprovalsView,
})
